import React from 'react';
import { Form, Checkbox as AntDCheckbox } from 'antd';

const Checkbox: React.FC<any> = ({isFormItem = true, name, label, valuePropName, style, customLayout, wrapperClassName = '', noMargin = false, ...props}) => {
    let labelCol: any = { span: 8 };
    let wrapperCol: any = { span: 6 };

    if (customLayout) {
        if (typeof customLayout === 'object') {
            labelCol = customLayout.labelCol || undefined;
            wrapperCol = customLayout.wrapperCol || undefined;
        } else {
            labelCol = undefined;
            wrapperCol = undefined;
        }
    }

    if (noMargin) {
        wrapperClassName = 'm-0 '
    }

    return isFormItem ? (
        <Form.Item
            className={wrapperClassName}
            name={name}
            label={label}
            valuePropName={valuePropName}
            labelCol={labelCol}
            wrapperCol={wrapperCol}
            style={style}
        >
            <AntDCheckbox {...props} />
        </Form.Item>
    ) : (
        <AntDCheckbox {...props} />
    )
}

export default Checkbox;
